import type { Address } from '@gm-commercial/location-model';
import type {
  EffectiveUserPreferencesDto,
  HierarchyObjectView,
  InviteDto,
} from '@gm-commercial/rtk-clients/users/types';

import type { Role } from './role.model';

export enum InvitationStatus {
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
}

/** Alias of the generated users-API invite DTO. */
export type Invite = InviteDto;

//TODO:Remove during integration
export interface User {
  id: string;
  firstName: string;
  lastName: string;
  role: Role;
  email: string;
  /**
   * @deprecated name is redundant with displayName, which is closer to what the API returns, and will avoid an extra mapping.
   * Removal of this property in progress, please do not use in additional places.
   */
  name: string;
  displayName: string;
  status: ActivationStatus;
  phoneNumber?: string;
  address?: Address;
  organization?: OrganizationScopeEntity;
  hub?: UserScopeEntity;
  fleet?: UserScopeEntity;
  creationDate?: string;
  activationDate?: string;
  userPreferences?: {
    locale?: UserSupportedLocale;
    timeZone?: string;
    doNotShowLegalNotice?: boolean;
    showGettingStarted?: boolean;
  };
  /**
   * Units and formats profile-api resolved for this user, as opposed to the raw choices in
   * `userPreferences`. Every field is optional and every code a bare string, because the service
   * omits anything it has no opinion on and types the codes loosely; consumers are expected to
   * validate rather than trust the shape.
   */
  effectiveUserPreferences?: EffectiveUserPreferencesDto;
  lastSignedInDate?: string;
  invite?: Invite;
  migrated?: boolean;
  viewedAppSpaceCodes?: string[];
}

export enum ActivationStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  DISABLED = 'disabled',
  CONTACT = 'contact',
  RETIRED = 'retired',
}

// TODO: Remove in favor of localization-core `SUPPORTED_LOCALES`.
export enum UserSupportedLocale {
  en_US = 'en-US',
  en_CA = 'en-CA',
  fr_CA = 'fr-CA',
  es_MX = 'es-MX',
}

type UserScopeEntity = {
  id: string;
  name: string;
};

type OrganizationScopeEntity = UserScopeEntity &
  Pick<HierarchyObjectView, 'countryOfOperation' | 'currency'>;

export enum UserTabType {
  ORGANIZATION = 'organization',
  GM = 'gm',
}
export const SUPPORTED_USER_TAB = [UserTabType.ORGANIZATION, UserTabType.GM];
